export default {
  name: 'layerview',
  buttons: [
    {
      title: 'Enable/Disable Layer View',
      key: 'Ctrl+Shift+L'
    }
  ]
}
